import type { SteerReason } from "@roomate/core";

/** Plain-words label for each reason the Home screen asks for a steer. */
export const STEER_REASON_LABEL: Record<SteerReason, string> = {
  idle: "has gone quiet",
  failed_verifications: "keeps failing its checks",
  budget_hit: "hit its budget",
  overlap: "overlaps other work",
  merge_failed: "could not merge",
  abandoned_dependency: "has work blocked by an abandoned dependency",
  abandoned_merged: "was abandoned but landed on main",
  message_loop: "is stuck in a message loop",
  needs_login: "needs its owner to sign in again",
  no_builder: "has nobody who may build it",
};
